__turbopack_context__.v({
  "className": "cormorant_garamond_f8180439-module__nEpzva__className",
  "variable": "cormorant_garamond_f8180439-module__nEpzva__variable",
});
